import { Box, styled, Chip } from '@mui/material';
import pallet from '../../../layouts/pallet';

export const StudentDetailsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '40px',
  alignItems: 'center',
  '@media (min-width:900px)': {
    flexDirection: 'row'
  }
}));

export const ChipsContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '8px'
}));

export const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'chipcolor'
})<{ chipcolor?: 'success' | 'danger' | 'neutral' }>(() => ({
  marginRight: '8px',
  '&.success': {
    background: pallet.lightGreen,
    '&:hover': {
      background: pallet.lightGreen
    },
    '& .MuiChip-label': {
      color: pallet.successMain
    }
  },
  '&.danger': {
    background: pallet.lightRed,
    '&:hover': {
      background: pallet.lightRed
    },
    '& .MuiChip-label': {
      color: pallet.red2
    }
  }
}));

export const StudentInfoRow = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  rowGap: '16px'
}));

export const StudentInfoItem = styled(Box)(() => ({
  width: '100%',
  paddingRight: '16px',
  '@media (min-width:600px)': {
    width: '50%'
  },
  '@media (min-width:1200px)': {
    width: '25%'
  }
}));
